import { motion } from "framer-motion";
import { Boxes, ScanLine, Spline } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/data/content";

const icons = [ScanLine, Spline, Boxes];

export const ServiceMethod = () => {
  const { t } = useLang();

  return (
    <div data-testid="services-method" className="mt-28 border-t border-white/10 pt-16 md:mt-36 md:pt-24">
      <div className="grid gap-10 lg:grid-cols-[0.72fr_1.28fr] lg:gap-20">
        <div>
          <p className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-[#00F0FF]">
            {t.services.method.overline}
          </p>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-zinc-500">{t.services.method.description}</p>
        </div>
        <h2 className="max-w-4xl font-heading text-3xl font-medium tracking-tight text-white sm:text-4xl">
          {t.services.method.title}
        </h2>
      </div>

      <motion.figure
        data-testid="services-method-image"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.25 }}
        transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
        className="mt-14 overflow-hidden border border-white/10 bg-white sm:mt-16"
      >
        <img src={IMAGES.services.method} alt="" className="block w-full object-cover" />
      </motion.figure>

      <div className="mt-4 border-t border-white/10">
        {t.services.method.items.map((item, index) => {
          const Icon = icons[index];
          return (
            <motion.article
              key={item.title}
              data-testid={`services-method-item-${index + 1}`}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="grid gap-5 border-b border-white/10 py-8 md:grid-cols-[72px_0.72fr_1.28fr] md:gap-10"
            >
              <div className="flex items-start gap-3 text-[#00F0FF]">
                <Icon className="h-5 w-5" aria-hidden="true" />
                <span className="font-mono text-xs tracking-[0.16em]">0{index + 1}</span>
              </div>
              <h3 className="font-heading text-xl font-medium text-white">{item.title}</h3>
              <p className="text-sm leading-relaxed text-zinc-400">{item.description}</p>
            </motion.article>
          );
        })}
      </div>
    </div>
  );
};